import React, { useState } from "react";
import { apiPostForm, apiPutForm, API_BASE } from "../../admin/api";
import "./partner-form-page.css";

export default function PartnerForm({ initial, onSaved, onCancel }) {
  const [name, setName] = useState(initial?.name || "");
  const [image, setImage] = useState(null);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      const body = { name };
      if (image) body.image = image;

      if (initial?.id) {
        await apiPutForm(`/api/partners/${initial.id}`, body);
      } else {
        await apiPostForm(`/api/partners`, body);
      }

      onSaved?.();
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="partner-form-page minimalist">
      <section className="pf-left">
        <div className="card">
          <label className="f">
            <span className="f__label">Partner Name</span>
            <input
              className="f__input"
              placeholder="Enter company / partner name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>
        </div>

        <div className="card">
          <div className="card__title">Logo / Image</div>
          <input
            className="f__input"
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files?.[0] || null)}
          />

          {initial?.image && !image && (
            <div className="pf-preview">
              <img src={`${API_BASE}${initial.image}`} alt={initial.name} />
            </div>
          )}
        </div>
      </section>

      <aside className="pf-right">
        <div className="card slim">
          <div className="card__title">Actions</div>
          <div className="row end gap">
            <button type="button" className="btn btn--sm" onClick={onCancel}>
              Cancel
            </button>
            <button disabled={saving} className="btn primary">
              {saving ? "Saving..." : initial ? "Save Changes" : "Add Partner"}
            </button>
          </div>
        </div>
      </aside>
    </form>
  );
}